// extracted by mini-css-extract-plugin
module.exports = {"panel":"style_panel__1E7Hv","inner":"style_inner__1fTs0","recently":"style_recently__2wZ9m","period":"style_period__33PhW","total":"style_total__RGDty"};